import { FC } from 'react'

import styled from 'styled-components'

import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'
import { GetSmsWhenApprovedModal } from 'src/Components/GetSmsWhenApprovedModal'

import { AlertsBlock } from './CampaignList/AlertsBlock'
import { CampaignListHeader } from './CampaignListHeader/CampaignListHeader'
import { useCampaigns } from './useCampaigns'
import { CampaignList } from './CampaignList'
import { useSmsApprovalModal } from './useSmsApprovalModal'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;

  @media (min-width: ${MAX_MOBILE_WIDTH}) {
    max-width: 1120px;
    padding: 40px;

    align-items: flex-start;
    align-self: stretch;
    border-radius: 16px;
    border: 1px solid ${(props) => props.theme.color.lightGrey};
    background-color: ${(props) => props.theme.color.white};
    box-shadow: ${(props) => props.theme.shadow.card};
  }
`

export const CampaignsListPage: FC = () => {
  const { loading, campaigns, hasCampaigns } = useCampaigns()
  const { isOpen, isEligible, openModal, closeModal } = useSmsApprovalModal()
  return (
    <Container>
      <CampaignListHeader loading={loading} hasCampaigns={hasCampaigns} />
      <AlertsBlock loading={loading} />
      <CampaignList
        campaigns={[...campaigns]}
        loading={loading}
        onSmsNotifyClick={isEligible ? openModal : void 0}
      />
      <GetSmsWhenApprovedModal isOpen={isOpen} onClose={closeModal} />
    </Container>
  )
}
